import { compareAccDocKey } from "../../decorators/StoreIdEquality";
import { StoreName } from "../../decorators/StoreNameDecorator";
import AcceleratorDoc, {
  AcceleratorDocData,
  AcceleratorDocStoreKey,
} from "../../models/AcceleratorDoc";
import API from "../../models/API";
import { BatchClassConfig } from "../../models/config/BatchClassConfig";
import { AbstractRemovableStore } from "../RemovableStore";

const SELECT_ALL_BATCH_INSTANCES = "ALL";
@StoreName("AcceleratorDocStore")
class AcceleratorDocStoreClass extends AbstractRemovableStore<
  AcceleratorDocStoreKey,
  AcceleratorDoc
> {
  storedObjectKeysEquals(
    a: AcceleratorDocStoreKey,
    b: AcceleratorDocStoreKey,
  ): boolean {
    return compareAccDocKey(a, b);
  }

  /**
   * Find an AcceleratorDoc by Batch UUID and DocId.
   * @param compositeKey
   * @throws {'Error' | 'Stale'}
   * @returns AcceleratorDoc if instantiated, undefined if AcceleratorDoc was invalid.
   */
  async lookup(
    compositeKey: AcceleratorDocStoreKey,
  ): Promise<AcceleratorDoc | undefined> {
    return await API.get(
      `/v0/document/${compositeKey.batchInstanceUuid}/${compositeKey.docId}`,
    )
      .then(async (value: Response) => {
        if (!value.ok && value.status === 404) {
          console.error(
            `AcceleratorBatch ${compositeKey.batchInstanceUuid} is stale !`,
          );
          throw new Error("stale");
        }
        if (!value.ok) {
          return undefined;
        }
        const docData: AcceleratorDocData =
          (await value.json()) as AcceleratorDocData;
        if (docData) {
          return new AcceleratorDoc({
            ...docData,
            batchInstanceUuid: compositeKey.batchInstanceUuid,
          });
        } else {
          return undefined;
        }
      })
      .catch((e?: any) => {
        console.log("Could not load AcceleratorDoc", e);
        if (e === "stale" || e?.message === "stale") {
          throw e;
        }
        return undefined;
      });
  }

  getAll(): Array<AcceleratorDoc> {
    const returnValues = this.values;
    // SweetListSorter.sort(returnValues, (data) => data.batchInstanceId, 'DOC', 10);
    return returnValues;
  }

  getByBatchInstanceUuid(
    /*batchClassConfig: BatchClassConfig,*/ batchInstanceUuid: string,
  ): Array<AcceleratorDoc> {
    // FIXME: remove legacy filter handling here
    if (batchInstanceUuid === SELECT_ALL_BATCH_INSTANCES) {
      // return this.getByBatchClassConfig(batchClassConfig);
      // alert('AcceleratorDocStore.getByBatchInstanceUuid recieved ' + SELECT_ALL_BATCH_INSTANCES);
      throw new Error(
        "AcceleratorDocStore.getByBatchInstanceUuid does not accept ALL filter",
      );
    }
    return this.values.filter(
      (x) => x.storeId.batchInstanceUuid === batchInstanceUuid,
    );
  }

  getByBatchClassConfig(
    batchClassConfig: BatchClassConfig,
  ): Array<AcceleratorDoc> {
    return this.values.filter(
      (accDoc) => accDoc.getBatchClassId() === batchClassConfig.batchClassId,
    );
  }

  //@ts-expect-error
  _vamp(values) {
    //@ts-expect-error
    this.values = values.map((r) => new AcceleratorDoc(r));
  }
  _unvamp() {
    return this.values;
  }
}

const AcceleratorDocStore = new AcceleratorDocStoreClass();
export {
  AcceleratorDocStore,
  SELECT_ALL_BATCH_INSTANCES,
  AcceleratorDocStoreClass,
};
